<div class="container">
  <section class="title-container">
    <!--<span class="summary">{{ quantidadeProfessores + 1 }}-{{ quantidadeProfessores + 1 }}</span>-->
  </section>
  <app-loader></app-loader>
  <div style="width: 100%;">

    <div class="container mini-banner">
      <div class="row">
        <div class="icone-banner">
          <img alt="poa finalizada" src="assets/images/auto_awesome.svg"/>
        </div>
        <div class="texto-banner">
          <span class="texto-finalizacao">{{ 'questionario.comentarios.titulo-finalizacao' | translate }}</span>
        </div>
      </div>
      <div class="row" *ngIf="statusComentario">
        <div class="texto-banner-comentario">
          <span>{{ 'questionario.comentarios.titulo-finalizacao-comentario' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="row" style="padding-bottom: 24px;"></div>
    <div class="texto-comentario" style="padding-top: 20px;" *ngIf="!statusComentario">
      <h3>{{ 'questionario.comentarios.fazer-comentario' | translate }}</h3>
    </div>

    <div class="comment-section" *ngIf="!statusComentario">
      <div>
        <textarea style="width: 100%; padding: 8px 16px;" maxlength="4000" placeholder="Escreva o comentário aqui..." class="textarea-comentario"
          (input)="change($event.target.value)">{{comentario?.observacoes}}</textarea>
        <span *ngIf="comentario?.observacoes.length < 3999" class="caracter-comentario">
          <i class="far fa-keyboard"></i>
          {{ 4000 - comentario?.observacoes.length }}
          *
          {{ 'questionario.comentarios.caracteres' | translate }}
        </span>

        <span *ngIf="comentario?.observacoes.length >= 3999" class="caracter-comentario">
          <i class="far fa-keyboard"></i>
          {{ 4000 - comentario?.observacoes.length }}
          *
          {{ 'questionario.comentarios.caracter' | translate }}
        </span>
      </div>

      <div class="btn-container">
        <app-button [ngClass]="{ active: comentariosend }" (click)="salvar()">
          <strong>
            <i class="fas fa-chevron-right"></i>
            {{ 'questionario.comentarios.salvar' | translate }}
          </strong>
        </app-button>
      </div>
    </div>

    <app-feedback *ngIf="salvo || statusComentario" message="questionario.comentarios.sucesso"></app-feedback>

  </div>
</div>
